module.exports = __webpack_public_path__ + "img/UTTHIS.3cbb8620.png";